export default "__VITE_ASSET__VXNzxvzX__"